const styles = theme => ({
  container: {
    backgroundColor: "#FDFDF9",
    padding: 48
  },
  features: {
    display: "flex",
    justifyContent: "space-around"
  },
  feature: {
    textAlign: "center",
    maxWidth: 230
  },
  featureIcon: {
    marginTop: 8,
    height: 20
  },
  featureTitle: {
    color: "rgba(0,0,0,0.87)",
    textAlign: "center",
    fontSize: "1rem",
    marginTop: 12,
    marginBottom: 12
  },
  [theme.breakpoints.down("xs")]: {
    features: {
      flexDirection: "column",
      alignItems: "center"
    },
    feature: {
      marginBottom: 24,
      "&:last-child": {
        marginBottom: 0
      }
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/screens/Home/WhyUsStyles.js